import c3 from "c3";
import * as d3 from "d3";
import moment from "moment";
import "./TempoTractionModal.css";

export const drawCharts = (impactCont, tractionCont, data) => {
    const isHourly = (data) => {
        data = data.sort();
        return data[data.length - 1] - data[0] < 24 * 59 * 60 * 1000;
    };
    data.dates = data.dates.slice(1);
    data.dates.pop();

    let dates = data.dates.map((d) => new Date(d));
    let dates_int = dates.map(function (d) {
        return new Date(d).getTime();
    });
    /*virality coordinates calculation */
    let thresholdValue = data["viralChartInfo"]["orgThresholdValue"];
    let passedViralDate = new Date(data["viralChartInfo"]["wentViralOn"]).getTime();
    let predictedViralTime = data["viralChartInfo"]["aboutToViralOn"];

    data.impact = data.impact.slice(1);
    data.traction = data.traction.slice(1);

    data.impact.pop();
    data.traction.pop();
    data.traction = data.traction.map((x) => x.toFixed(3));

    let is_hourly = isHourly(dates_int);
    let boundingRect = impactCont.getBoundingClientRect();
    let diff_adder = 0;

    let start_date = new Date(dates_int[0]);
    let end_date = new Date(dates_int[dates_int.length - 1]);

    // let days_diff = moment(end_date).diff(start_date, 'days');
    let __duration = moment.duration(moment(end_date).diff(start_date));
    let __hours = __duration.asHours();
    let __interval = __hours / data.impact.length;

    let roundAnyDate = (_date) => {
        let __date = new Date(_date);
        let __min = __date.getMinutes();
        if (__min >= 30) {
            __date.setHours(__date.getHours() + 1, 0, 0, 0);
        } else {
            __date.setMinutes(0, 0, 0);
        }
        return __date;
    };

    // let __myStartDate=new Date(moment(start_date).subtract(__interval,'h'))
    let __myStartDate = new Date(moment(start_date));
    let __myStartDateRound = roundAnyDate(__myStartDate);
    let roundedDownDate = new Date(moment(__myStartDateRound).subtract(1, "h"));
    let __myEndate = new Date(moment(end_date));
    let __myEndateRound = roundAnyDate(__myEndate);
    let roundedUpDate = new Date(moment(__myEndateRound).add(1, "h"));

    let axis_date_values = [];
    axis_date_values.push(roundedDownDate);
    let __point1 = roundedDownDate;
    let __point2 = roundedUpDate;
    var __midPoint = moment.duration(moment(__point2).diff(__point1));
    var __midPointAsHour = __midPoint.asHours();
    if (__midPointAsHour % 2 != 0) {
        roundedUpDate = new Date(moment(roundedUpDate).add(1, "h"));
        let newMidPoint = moment.duration(moment(roundedUpDate).diff(roundedDownDate));
        __midPointAsHour = newMidPoint.asHours();
    }
    axis_date_values.push(roundAnyDate(new Date(moment(__point1).add(__midPointAsHour / 2, "h"))));

    axis_date_values.push(roundedUpDate);

    let predictedViralDate = new Date(dates_int[0]).setHours(0, 0, 0, 0);
    let maxRange = "";
    let xline, yline, maxX, maxY;
    if (predictedViralTime > 0 && isNaN(passedViralDate)) {
        predictedViralDate = new Date(moment(end_date).add(predictedViralTime, "seconds"));
        maxRange = new Date(moment(end_date).add(6, "hours"));
        let Viraltext = `Predicted Viral On-${new Date(predictedViralDate).toDateString()}`;

        maxX = moment(axis_date_values[axis_date_values.length - 1]).add(10, "m");
        let _maxY = data.impact[data.impact.length - 1] + (1 / 10) * data.impact[data.impact.length - 1];
        maxY = _maxY >= thresholdValue ? thresholdValue : _maxY;
        // maxY = data.impact[data.impact.length-1] + (1/8) * (data.impact[data.impact.length-1])
        yline = { value: maxY, class: "avgBandValueUpper", text: "", position: "middle" };
        xline = { value: moment(axis_date_values[axis_date_values.length - 1]).add(10, "m"), class: "avgBandValueUpper", text: Viraltext, position: "middle" };
    }
    if (maxRange < axis_date_values[axis_date_values.length - 1]) {
        xline = { value: -1, class: "avgBandValueUpper", text: "", position: "middle" };
        yline = { value: thresholdValue, class: "avgBandValueUpper", text: "", position: "middle" };
        maxX = moment(axis_date_values[axis_date_values.length - 1]);
        maxY = data.impact[data.impact.length - 1];
    }

    let maxImpactValue = data.impact[data.impact.length - 1];
    var chart1 = c3.generate({
        padding: {
            right: 20,
        },
        bindto: impactCont,
        size: {
            height: 300,
        },
        data: {
            x: "x",
            columns: [["x"].concat(dates_int), ["impact"].concat(data.impact)],
            type: "line",
            color: function (color, d) {
                return "#00A52C";
            },
        },
        grid: {
            x: {
                show: true,
                lines: [xline],
            },
            y: {
                lines: [yline],
            },
        },
        axis: {
            x: {
                type: "timeseries",
                values: axis_date_values.length + 1,
                tick: {
                    format: "%d-%m-%y %H:%M",
                    width: 50,
                    multiline: true,
                    values: axis_date_values,
                    padding: {
                        right: 10,
                    },
                },
                height: 100,
                min: axis_date_values[0],
                max: maxX,
            },
            y: {
                min: 0,
                tick: {
                    format: function (x) {
                        if (x > maxImpactValue && thresholdValue > maxY) return "";
                        else return x;
                    },
                },
                max: maxY,
            },
        },
        legend: {
            show: false,
        },
    });

    let maxTractionDateRange = axis_date_values[axis_date_values.length - 1];

    var chart2 = c3.generate({
        bindto: tractionCont,
        padding: {
            right: 20,
        },
        size: {
            height: 300,
        },
        data: {
            x: "x",
            columns: [["x"].concat(dates), ["traction"].concat(data.traction)],
            type: "line",
            color: function (color, d) {
                return "#00A52C";
            },
        },
        grid: {
            x: {
                show: true,
            },
        },
        axis: {
            x: {
                type: "timeseries",
                tick: {
                    values: axis_date_values,
                    format: "%d-%m-%y %H:%M",
                    width: 50,
                    multiline: true,
                },
                height: 100,
                min: axis_date_values[0],
                max: maxTractionDateRange,
            },
            y: {
                min: 0,
            },
        },
        legend: {
            show: false,
        },
    });
};
